import BaseUserDataSection from './BaseUserDataSection'
import {isEmailValid, trim} from '../../atUtils'
import $ from 'jquery'
import {ValidationErrors} from '../../panels/user/constants'
import {isEnterPressed, isEscapePressed} from '../../atBrowserUtils'

class BaseUserInformationSection extends BaseUserDataSection
{
}

const UserInformationErrors = {
    [ValidationErrors.FIRST_NAME_EMPTY]: true,
    [ValidationErrors.LAST_NAME_EMPTY]: true,
    [ValidationErrors.EMAIL_EMPTY]: true,
    [ValidationErrors.EMAIL_INVALID]: true,
    [ValidationErrors.PASSWORD_EMPTY]: true,
    [ValidationErrors.PASSWORDS_DO_NOT_MATCH]: true,
    [ValidationErrors.PASSWORD_COPY_EMPTY]: true,
    [ValidationErrors.OLD_PASSWORD_EMPTY]: true,
    [ValidationErrors.OLD_PASSWORD_INCORRECT]: true,
    [ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED]: true,
    [ValidationErrors.USERNAME_EMPTY]: true,
    [ValidationErrors.USERNAME_DUPLICATE]: true,
    [ValidationErrors.NEW_USER_GROUP_EMPTY]: true,
    [ValidationErrors.NEW_TIME_ZONE_GROUP_EMPTY]: true,
    [ValidationErrors.DUPLICATE_TIME_ZONE_GROUP]: true,
    [ValidationErrors.CITY_DATA_EMPTY]: true,
    [ValidationErrors.HIRE_DATE_EMPTY]: true,
    [ValidationErrors.HIRE_DATE_IN_FUTURE]: true,
    [ValidationErrors.HIRE_DATE_IN_FUTURE_FOR_SELF]: true,
}

BaseUserInformationSection.prototype.init = function({
    lightBoxEl = null,
    sectionId = '',
    userData = null,
    changesCallback = () => {},
    validateCallback = () => {},
    isInstantValidation = false,
    needValidation = true
})
{
    BaseUserDataSection.prototype.init.call(this, lightBoxEl, changesCallback, validateCallback);

    this._isInstantValidation = isInstantValidation;
    this.needValidation = needValidation

    this.sectionEl = this.getElementBySubId( sectionId );
    this.firstNameField = this.$subId("firstNameField");
    this.lastNameField = this.$subId("lastNameField");
    this.middleNameField = this.$subId("middleNameField");
    this.emailField = this.$subId("emailField");

    this.firstNameField.off();
    this.lastNameField.off();
    this.middleNameField.off();
    this.emailField.off();

    this.setValue( this.firstNameField, userData.firstName );
    this.setValue( this.lastNameField, userData.lastName );
    this.setValue( this.middleNameField, userData.middleName );
    this.setValue( this.emailField, userData.email );


    this.firstNameField.placeholder();
    this.lastNameField.placeholder();
    this.middleNameField.placeholder();
    this.emailField.placeholder();

    this.errors = {};

    var self = this;

    var keyUpChangesHandler = function()
    {
        this.keyPressed = false;
        if( (!this.prevValue && !!this.value) || this.prevValue != this.value )
            self.changesDetected( true );
    };

    this.onKeyPressedHandler = function () {
        this.keyPressed = true;
    };

    this.onBlurFieldHandler = (validator) => {
        return function() {
            keyUpChangesHandler.call(this)

            $(this).pVal(trim(this.value))
            //see Bug 48539
            if (this.keyPressed) keyUpChangesHandler.call(this)

            validator()
            $(this).trigger("changed", [$(this).pVal()])
            self.updateUI()
            self.validationDetected()
        }
    }

    const firstNameBlurHandler = this.onBlurFieldHandler(() => { return self.needValidation ? self._checkFirstNameValid(true) : true })
    const lastNameBlurHandler = this.onBlurFieldHandler(() => { return self.needValidation ? self._checkLastNameValid(true) : true })
    const middleNameBlurHandler = this.onBlurFieldHandler(() => { return true })
    const emailBlurHandler = this.onBlurFieldHandler(() => { return self.needValidation ? self._checkEmailValid(true) : true })

    const subscribeFieldEvents = ($field, blurHandler) => {
        $field.blur(blurHandler)
              .keydown(e => {
                  if (isEscapePressed(e) || isEnterPressed(e)) {
                      $field.blur()
                      e.stopPropagation()
                  }
              })
    }

    subscribeFieldEvents(this.firstNameField, firstNameBlurHandler)
    subscribeFieldEvents(this.lastNameField, lastNameBlurHandler)
    subscribeFieldEvents(this.middleNameField, middleNameBlurHandler)
    subscribeFieldEvents(this.emailField, emailBlurHandler)

    this.updateUI();
    return this;
};

BaseUserInformationSection.prototype.$subId = function( subId )
{
    return $( this.getElementBySubId( subId ) );
};

BaseUserInformationSection.prototype.setValue = function( field, value )
{
    field.removeClass('placeholder'); // IE8 doesn't switch placeholder class when field value is set
    field[0].value = value;
    field[0].prevValue = field[0].value;
};

BaseUserDataSection.prototype.setDisabled = function(disabled)
{
    this.firstNameField.prop('disabled', disabled)
    this.middleNameField.prop('disabled', disabled)
    this.lastNameField.prop('disabled', disabled)
    this.emailField.prop('disabled', disabled)
}

BaseUserInformationSection.prototype.setUpNameCallback = function( nameCallback )
{
    if( !nameCallback )
        return;

    this._nameChangedCallback = nameCallback;
    var self = this;
    var keyUpHandler = function() { this.keyPressed = false; self.nameKeyUpHandler( this ); };

    this.firstNameField.keyup( keyUpHandler );
    this.firstNameField.blur( keyUpHandler );

    this.lastNameField.keyup( keyUpHandler );
    this.lastNameField.blur( keyUpHandler );

    this.middleNameField.keyup( keyUpHandler );
    this.middleNameField.blur( keyUpHandler );
};


BaseUserInformationSection.prototype.nameKeyUpHandler = function( field )
{
    var $field = $(field);
    if( !field.prevValue || field.prevValue != $field.pVal() )
    {
        field.prevValue = $field.pVal();
        this._nameChanged();
    }
};

BaseUserInformationSection.prototype._nameChanged = function()
{
    this._nameChangedCallback( this.firstNameField.pVal(), this.lastNameField.pVal(), this.middleNameField.pVal() );
};

BaseUserInformationSection.prototype._isEmailValid = function( email )
{
    return email.length == 0 || isEmailValid ( email );
};

BaseUserInformationSection.prototype._checkEmailValid = function(onlyRemoveEmptyError )
{
    this.errors[ValidationErrors.EMAIL_INVALID] = false

    if ( !this._checkEmpty( this.emailField, ValidationErrors.EMAIL_EMPTY, onlyRemoveEmptyError ) )
        this.errors[ValidationErrors.EMAIL_INVALID] = !this._isEmailValid( this.getEmail() )

    return !this.errors[ValidationErrors.EMAIL_INVALID]
};

BaseUserInformationSection.prototype.setEmailInvalid = function(){
    this.errors[ValidationErrors.EMAIL_INVALID] = true
    this.validate();
    this.updateUI();
};

BaseUserInformationSection.prototype._checkFirstNameValid = function( onlyRemoveEmptyError )
{
    return !this._checkEmpty( this.firstNameField, ValidationErrors.FIRST_NAME_EMPTY, onlyRemoveEmptyError );
};

BaseUserInformationSection.prototype._checkLastNameValid = function( onlyRemoveEmptyError )
{
    return !this._checkEmpty( this.lastNameField, ValidationErrors.LAST_NAME_EMPTY, onlyRemoveEmptyError );
};

BaseUserInformationSection.prototype._checkEmpty = function ( field, errorCode, onlyRemoveEmptyError )
{
    if( field.pVal().length == 0 )
    {
        if( !onlyRemoveEmptyError || this._isInstantValidation )
        {
            this.errors[ errorCode ] = true;
        }
    }
    else
    {
        this.errors[ errorCode ] = false;
    }
    return this.errors[ errorCode ];
};



BaseUserInformationSection.prototype.validate = function()
{
    if (!this.needValidation)
        return true

    var oldErrors = this.errors;
    this.errors = {};
    this._checkFirstNameValid();
    this._checkLastNameValid();
    this._checkEmailValid(false,oldErrors);
    this.customValidate(oldErrors);

    this.updateUI();
    return !this.hasErrors();
};

BaseUserInformationSection.prototype.customValidate = function( oldErrors )
{
};

BaseUserInformationSection.prototype.updateUI = function()
{
    var classes = [];
    for( var p in this.errors )
        if (this.errors[p] && UserInformationErrors.hasOwnProperty(p))
            classes.push(p)
    this.sectionEl.className = classes.join(" ");
};

BaseUserInformationSection.prototype.getFirstName = function()
{
    return this.firstNameField.pVal();
};

BaseUserInformationSection.prototype.getLastName = function()
{
    return this.lastNameField.pVal();
};

BaseUserInformationSection.prototype.getMiddleInitial = function()
{
    return this.middleNameField.pVal();
};

BaseUserInformationSection.prototype.getEmail = function()
{
    return this.emailField.pVal();
};

BaseUserInformationSection.prototype.getSectionElement = function(  )
{
    return this.sectionEl;
};

export default BaseUserInformationSection



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/BaseUserInformationSection.js